import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BaseComponent } from 'src/app/secondadmin/base.component';
import { ClientService } from 'src/app/services/clients/client.service';
import { MasterService } from 'src/app/services/master/master.service';

@Component({
  selector: 'app-add-subscription-feature',
  templateUrl: './add-subscription-feature.component.html',
  styleUrls: ['./add-subscription-feature.component.css']
})
export class AddSubscriptionFeatureComponent extends BaseComponent implements OnInit {

  customer_id;
  addFeatureForm: FormGroup;
  getCompanyobj: any = [];
  submitted = false;
  subsObj: any = [];
  selectedSubs: any = [];
  featureValues: any = {};
  constructor(
    private formBuilder: FormBuilder,
    private clientsService: ClientService,
    private masterService: MasterService
  ) { super(); }

  ngOnInit(): void {
    this.customer_id = JSON.parse(sessionStorage.getItem('userData')).admin_customer_id;
    if (this.customer_id == 0) this.getCompany();
    this.addFeatureForm = this.formBuilder.group({
      feature_name: ['', [Validators.required, Validators.maxLength(100)]],
      feature_slug: ['', [Validators.maxLength(100)]],
      feature_type: ['boolean', Validators.required],
      feature_desc: [''],
      order_no: [''],
      selectedCompany: [(this.customer_id == 0) ? this.getDefaultCompanyId() : this.customer_id, Validators.required]
    });
    if (this.customer_id != 0) {
      this.loadSubscriptions(this.customer_id);
    } else if (this.addFeatureForm.value.selectedCompany) {
      this.loadSubscriptions(this.addFeatureForm.value.selectedCompany);
    }
  }
  getCompany() {
    let self = this;
    this.clientsService.getBUCompanies().subscribe(data => {
      self.getCompanyobj = data.data;
      const working = self.bindWorkingCompany(self.getCompanyobj);
      if (working && !self.addFeatureForm.value.selectedCompany) {
        self.addFeatureForm.patchValue({ selectedCompany: working });
        self.loadSubscriptions(working);
      }
    }, error => {
      console.log(error);
    });
  }
  loadSubscriptions(companyId?) {
    const company = companyId || this.addFeatureForm.value.selectedCompany;
    this.selectedSubs = [];
    this.featureValues = {};
    if (!company) {
      this.subsObj = [];
      return;
    }
    this.ngxSpinnerService.show();
    this.masterService.getSubscriptionListDropdown(company, 1000, 0).subscribe(data => {
      this.ngxSpinnerService.hide();
      if (data.status && data.data && data.data.rows) {
        this.subsObj = data.data.rows;
      } else {
        this.subsObj = [];
      }
    }, error => {
      console.log(error);
      this.subsObj = [];
      this.ngxSpinnerService.hide();
    });
  }
  isSubChecked(id) {
    return this.selectedSubs.indexOf(Number(id)) > -1;
  }
  defaultFeatureValue() {
    return this.addFeatureForm.value.feature_type === 'boolean' ? 'true' : '';
  }
  toggleSub(id, checked) {
    id = Number(id);
    if (checked) {
      if (this.selectedSubs.indexOf(id) === -1) {
        this.selectedSubs.push(id);
      }
      if (!this.featureValues[id]) {
        this.featureValues[id] = this.defaultFeatureValue();
      }
    } else {
      this.selectedSubs = this.selectedSubs.filter(item => Number(item) !== id);
    }
  }
  buildAssignments() {
    return this.selectedSubs.map(id => {
      const value = (this.featureValues[id] || this.defaultFeatureValue() || 'true').toString().trim();
      return { sub_id: Number(id), feature_value: value || 'true' };
    });
  }
  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }
  get f() { return this.addFeatureForm.controls; }
  addNewFeatureData() {
    this.submitted = true;
    if (this.addFeatureForm.invalid) {
      return;
    }
    let { selectedCompany } = this.addFeatureForm.value;
    const body = Object.assign({}, this.addFeatureForm.value, {
      assignments: this.buildAssignments()
    });
    this.masterService.addSubscriptionFeature(body, selectedCompany).subscribe(data => {
      if (data.status) {
        this.toastrService.success("Subscription feature added successfully");
        this.router.navigateByUrl(`/corporate/subscription-feature-list`);
      } else {
        this.toastrService.error(data.message);
      }
    }, error => {
      this.toastrService.error(error.message);
    });
  }

}
